import useChainFlow from 'core/guestBooking/useChainFlow';
import { loadAccessRequestForm, updateAccessRequestForm } from './accessRequestFormApi';

/**
 * The access chain's step flow, serving both an authenticated request and a
 * guest (booking-link) one. See useChainFlow.
 */
const useAccessFlow = () => useChainFlow({
    basePath: 'access-request',
    loadThunk: loadAccessRequestForm,
    updateThunk: updateAccessRequestForm,
    reviewStep: 5,
});

export default useAccessFlow;
